import type { JSX } from 'react';
import { useVersionCheck } from '../hooks/useVersionCheck';

interface GsVersionBannerProps {
  apiBaseUrl: string;
}

/**
 * Banner discret en haut de page si un nouveau déploiement est détecté.
 * Bouton "Rafraîchir" force un reload du bundle.
 *
 * Respecte le design system GS : fond doux (brand-50), CTA brand-500,
 * border subtile, touch-manipulation sur mobile.
 */
export function GsVersionBanner({ apiBaseUrl }: GsVersionBannerProps): JSX.Element | null {
  const { hasUpdate } = useVersionCheck(apiBaseUrl);

  if (!hasUpdate) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="flex items-center justify-between gap-3 border-b border-brand-200 bg-brand-50 px-4 py-2 text-field text-slate-700 dark:border-brand-900/40 dark:bg-brand-950/20 dark:text-slate-200"
    >
      <span>
        Une nouvelle version de l'application est disponible.
      </span>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="ml-4 touch-manipulation rounded-md bg-brand-500 px-3 py-1 text-field font-medium text-white transition-colors hover:bg-brand-600"
      >
        Rafraîchir
      </button>
    </div>
  );
}
